import { queryAllPages } from '../../apollo/query-all-pages';
import { gql } from "@apollo/client";
import { client } from "../../apollo/client";

const DRIVERS_REQUESTS = gql`
  query GetDrivers {
    drivers(limit: 100, offset: 0) {
      data {
        codigo
        master
        status
        dataCadastro
        nome
        cnh
        categoria
        validade
        clienteMaster {
          codigo
          razaoSocial
        }
      }
      totalRecords
    }
  }
`;

export const getAllDrivers = async () => {
    
        const response = await queryAllPages(client, {
            query: DRIVERS_REQUESTS,
            // variables: {
            //   input: bar
            // }
        });
        const { data } = response.data.drivers;
        return data;
    
}
